import {
  AccordionDetailsProps,
  AccordionProps,
  AccordionSummaryProps,
  Typography,
} from '@mui/material';
import { ReactElement, ReactNode } from 'react';
import { DynamicIcon } from 'src/components/DynamicIcon/dynamic-icon';
import {
  SectionAccordion,
  SectionAccordionDetails,
  SectionAccordionSummary,
} from 'src/components/SidePanelTabs/SiteDocumentation/site-documentation.styles';

interface SiteDocumentationAccordionProps {
  title: ReactNode;
  expanded: boolean;
  onChange: AccordionProps['onChange'];
  children: ReactNode;
  summaryProps?: AccordionSummaryProps;
  detailsProps?: AccordionDetailsProps;
}

export const SiteDocumentationAccordion = ({
  title,
  expanded,
  onChange,
  children,
  summaryProps,
  detailsProps,
}: SiteDocumentationAccordionProps): ReactElement => (
  <SectionAccordion
    disableGutters
    square
    elevation={0}
    expanded={expanded}
    onChange={onChange}
  >
    <SectionAccordionSummary
      expandIcon={
        <DynamicIcon
          name="chevron-down"
          library="lucide"
          sx={{
            transition: 'transform 200ms',
          }}
        />
      }
      {...summaryProps}
    >
      {typeof title === 'string' ? (
        <Typography variant="subtitle2" fontSize="0.75rem">
          {title}
        </Typography>
      ) : (
        title
      )}
    </SectionAccordionSummary>
    <SectionAccordionDetails {...detailsProps}>{children}</SectionAccordionDetails>
  </SectionAccordion>
);
